angular
  .module('cfn')
  .factory('amazoneMachineService', [
    '$log',
    '$http',
    '$q',
    amazoneMachineService
  ]);

function amazoneMachineService($log, $http, $q) {
  // Private
  // ...
  var AMAZONE_URL = '/365FarmNet/rest/partner/amazone/doService';

  // Public
  return {
    /**
     * remove redundant settings if amountPerArea is identical
     * @returns copy of list with filtered settings and concatenated names
     */
    reduce: function(list) {
      const amounts = {};
      // create a copy
      const response = angular.copy(list);
      response.settings = response.settings
        .sort(function(valueA, valueB) {
          // Sort by amountPerArea, then by Name for comparison
          var result = valueA.amountPerArea - valueB.amountPerArea;
          if (result === 0)
            return valueA.fieldName.localeCompare(valueB.fieldName);
          else return result;
        })
        .filter(function(value, index, array) {
          // same amountPerArea as previous field?
          if (
            index > 0 &&
            array[index].amountPerArea == array[index - 1].amountPerArea
          ) {
            // save index of first amountPerArea value in Object "amounts"
            var aPA = array[index].amountPerArea;
            if (amounts[aPA] == null)
              // second hit
              amounts[aPA] = index - 1; // save index of first hit
            // add Fieldname

            // Feld nur in array[amounts[aPA]].fieldName, wenn noch nicht aufgenommen
            if (
              array[amounts[aPA]].fieldName.indexOf(array[index].fieldName) < 0
            ) {
              array[amounts[aPA]].fieldName += ', ' + array[index].fieldName;
            }

            // but not the Settings
            return false;
          } else {
            return true;
          }
        });
      return response;
    },

    /**
     * Liefert eine Liste an Maschineneinstellungen
     * @returns Promise
     */
    getData: function(params) {
      return $http.post(AMAZONE_URL, params);
    }
  };
}

export default amazoneMachineService;
